// Modules
import { createAction, props } from '@ngrx/store';

// Interfaces
import { INavigationItem } from '@shared/interfaces';

// ----------- General Actions -----------
// ---------------------------------------
export const setCurrentPage = createAction(
  '[General] - Set Current Page',
  props<{ payload: INavigationItem }>()
);
